import { useMemo } from 'react'
import { RecipeWall } from '@/components/recipes/RecipeWall'
import { useAllRecipes } from '@/lib/recipes'

// The recipes from one person, in the Modern style of Recipes: whole dishes that turn over to their cards. The wall
// needs each recipe's tile and card, which the circle's list of recipes carries, so they're taken from there.
export function FromWall({ familyId, personId }: { familyId: string; personId: string }) {
  const recipes = useAllRecipes(familyId, false)
  const theirs = useMemo(
    () => (recipes.data?.recipes ?? []).filter((r) => r.from?.id === personId),
    [recipes.data, personId],
  )
  return theirs.length > 0 ? <RecipeWall recipes={theirs} /> : null
}
